import React from "react";

import ButtonSpinner from "../Spinner/ButtonSpinner";
import { COLORS } from "../../utils/Colors";

interface IButton {
  title: string;
  loading?: string;
  width: number;
  height: number;
  disabled?: boolean;
  isLoading?: boolean;
  onClick: () => void;
}

const Button = (props: IButton) => {
  return (
    <button
      disabled={props.disabled}
      className="w-10/12 flex justify-center items-center gap-2"
      onClick={props.onClick}
      style={{
        height: props.height,
        background: props.disabled? COLORS.Disabled: COLORS.Brand,
        borderRadius: 10,
        border: "none",
        color: COLORS.White,
        cursor: props.disabled? 'not-allowed': 'pointer',
      }}
    >
      {props.isLoading && <ButtonSpinner />}
      {props.isLoading? props.loading : props.title}
    </button>
  );
};

export default Button;
